export const API_URL = 'https://cdn.clarosports.com/json/widgets_'
export const API_LOCAL = 'olimpicos/data/'
export const API_KEY = 'ZTMzNzExZWIyMTFkNGZlZWFkZmVhNmY5N2ZjNmI4YjA6OmFteGMtYXBpdXNlcg'
export const API_SECRET = 'YWE2NjA2ZDU0ODU1Y2M4YzY4M2U3N2FlMjEzNzQ1MDI4MzBjNGRhNDI5MzQzZDgxMzJmYmMwY2QwZTQ1MTE3MTo6ODFjYmEwMzk5NDRhMmUyNmY1M2FjNzQwY2I3ZWEzNmI='
export const SDK_URL = 'https://par-amxc-web.ovpobs.tv/sdk/ovp-sdk.js'
export const EDICIONES = ["gangwon", "paris", "paralimpicos_paris"];
export const TYPE_MEDALLERO = "medallero";
export const TYPE_MEDALLERO_OVP = "medallero-ovp";
export const TYPE_MEDALLERO_OVP_MIN = "medallero-ovp-min";
export const TYPE_CALENDARIO = "calendario";
export const TYPE_RESULTADOS_GENERALES= "resultados-generales";
export const TYPE_RESULTADOS_DEPORTE = "resultados-deporte";
export const TYPE_MEDALLERO_MINI = "medallero-mini";
export const TYPE_PLAYER_OVP = "player-ovp";
export const API_URL_OLI = 'https://clarosports.com/olimpicos/paris-2024/'
export const API_URL_IMG = 'https://cdn.clarosports.com'
// export const API_URL = 'https://cdn.clarosports.com/json/widgets_'
// export const API_LOCAL = "../data/";
// export const API_KEY = 'ZTMzNzExZWIyMTFkNGZlZWFkZmVhNmY5N2ZjNmI4YjA6OmFteGMtYXBpdXNlcg'
// export const API_SECRET = 'YWE2NjA2ZDU0ODU1Y2M4YzY4M2U3N2FlMjEzNzQ1MDI4MzBjNGRhNDI5MzQzZDgxMzJmYmMwY2QwZTQ1MTE3MTo6ODFjYmEwMzk5NDRhMmUyNmY1M2FjNzQwY2I3ZWEzNmI='
// export const SDK_URL = 'https://par-amxc-web.ovpobs.tv/sdk/ovp-sdk.js'
// export const EDICIONES = ["gangwon", "paris", "paralimpicos_paris"];
// export const TYPE_MEDALLERO = "medallero";
// export const TYPE_MEDALLERO_OVP = "medallero-ovp";
// export const TYPE_MEDALLERO_OVP_MIN = "medallero-ovp-min";
// export const TYPE_CALENDARIO = "calendario";
// export const TYPE_RESULTADOS_GENERALES= "resultados-generales";
// export const TYPE_RESULTADOS_DEPORTE = "resultados-deporte";
// export const TYPE_MEDALLERO_MINI = "medallero-mini";
// export const TYPE_PLAYER_OVP = "player-ovp";
// export const API_URL_OLI = 'https://clarosports.com/olimpicos/paris-2024/'
// export const API_URL_IMG = 'https://cdn.clarosports.com'